//
import BranchOfficeModel from "@/models/General/GBranchOffice"
import WarehouseTypeModel from "@/models/Warehouse/WhWarehouseType"

//
import { required } from "@/services/validations"

//
export default {
    warehouse: [
        {
            name: "name",
            type: "text-field",
            flex: {
                sm6: true,
                lg4: true,
            },
            props: {
                label: "Nombre",
                placeholder: "Nombre de bodega",
                rules: [ required ],
            },
        },
        {
            name: "wh_warehouse_type_id",
            type: "autocomplete-model",
            flex: {
                sm6: true,
                lg4: true,
            },
            props: {
                itemText: "type",
                itemValue: "id",
                label: "Tipo",
                model: WarehouseTypeModel,
                noObject: true,
                paramSearch: "type",
                rules: [ required ],
            },
        },
        {
            name: "g_branch_office_id",
            type: "autocomplete-model",
            flex: {
                sm6: true,
                lg4: true,
            },
            props: {
                itemText: "address",
                itemValue: "id",
                label: "Sucursal",
                model: BranchOfficeModel,
                noObject: true,
                paramSearch: "address",
                rules: [ required ],
            },
        },
        {
            name: "address",
            type: "text-field",
            flex: {
                sm6: true,
                lg8: true,
            },
            props: {
                label: "Dirección",
                rules: [ required ],
            },
        },
        {
            name: "is_waste_warehouse",
            type: "switch",
            flex: {
                sm6: true,
                lg4: true,
            },
            props: {
                label: "Es una bodega de merma",
            },
        },
        {
            name: "description",
            type: "textarea",
            flex: {
                lg12: true,
            },
            props: {
                label: "Descripción",
                rules: [ required ],
            },
        },
    ],
    warehouseType: [
        {
            name: "type",
            type: "text-field",
            flex: {
                lg12: true,
            },
            props: {
                label: "Nombre",
                rules: [ required ],
            },
        },
    ],
}